<template name="AppBarDropdown">
    <v-menu
      open-on-hover
      open-on-click
      close-on-click
      close-on-content-click
    >
      <template v-slot:activator="{ on }">
        <v-btn
          text
          v-on="on"
        >
          {{tab.text}}
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="(item, index) in tab.dropdown"
          router
          :key="index"
          :to="item.link"
        >
          <v-list-item-title>{{ item.text}}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
</template>

<script>
export default {
    name: "AppBarDropdown",

    props: {
    tab: Object
    },
    
    methods: {
        onClick (e, item) {
            e.stopPropagation()

            if (item.to || !item.href) return

            this.$vuetify.goTo(item.href.endsWith('!') ? 0 : item.href)
        },
    },
}
</script>